export default __webpack_public_path__ + "static/media/1998.e21116df.png";